import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Instancia } from '@app/models/processo.model';
import { InstanciaService } from '@app/services/instancia.service';
import { isEmpty } from 'lodash';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-instancia-form',
  templateUrl: './instancia-form.component.html'
})
export class InstanciaFormComponent implements OnInit {

  instancia: Instancia = new Instancia();
  lstErros: string[];
  aguardandoSolicitacao: boolean;
  titulo: string;

  constructor(
    private instanciaService: InstanciaService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService
    ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      
      this.titulo = id ? 'Editar instância' : 'Nova instância';
      if (isNaN(Number.parseInt(id, 10))){
        this.instanciaService.obterPorId(id).subscribe(data => {
          this.instancia = data;
        });
      }
    })
  }

  onSubmit(){
    this.aguardandoSolicitacao = true;

    if (isEmpty(this.instancia.Descricao)){
      this.toastrService.error("Instância sem descrição");
      this.aguardandoSolicitacao = false;
      return;
    }

    this.instanciaService.gravar(this.instancia).toPromise().then(
      () => this.router.navigate(['./configuracoes/instancia']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
